import { Api, ApiContext } from '../api';
import { useContext } from 'react';

export function useApi(): Api {
	return useContext(ApiContext);
}
